import { WavEncoderData } from './WavEncoderData'
import { useEffect, useMemo } from 'react'

export function useWavEncoder(): WavEncoder {
  const encoder = useMemo(() => new WavEncoder(), [])

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      return () => {
        encoder.worker.terminate()
      }
    }
  }, [encoder])

  return encoder
}

export class WavEncoder {
  worker = new Worker(new URL('./WavEncoder.worker.ts', import.meta.url))

  encode(audioBuffer: AudioBuffer): Promise<ArrayBuffer> {
    const channels = this.getChannels(audioBuffer)
    const data: WavEncoderData = {
      sampleRate: audioBuffer.sampleRate,
      channels,
    }
    this.worker.postMessage(data, channels)

    return new Promise<ArrayBuffer>((resolve, reject) => {
      this.worker.onmessage = (event) => resolve(event.data)
      this.worker.onerror = (error) => reject(error)
    })
  }

  private getChannels(audioBuffer: AudioBuffer): ArrayBuffer[] {
    const channels = []
    for (let i = 0; i < audioBuffer.numberOfChannels; i++) {
      channels.push(audioBuffer.getChannelData(i).buffer)
    }
    return channels
  }
}
